import { push } from 'connected-react-router';
import { connect } from 'react-redux';

import { showYourDoctor } from 'src/app/router/paths';
import { segmentTrack } from 'src/app/state/actions';
import { getCurrentPathname, getFacility, isLoggedIn } from 'src/app/state/selectors';
import type { Dispatch, RootState } from 'src/app/state/store';

import { ShowYourDoctor as ShowYourDoctorRenderer } from '.';

const mapStateToProps = (state: RootState) => {
  const facility = getFacility(state);
  return {
    facility,
    pagepath: getCurrentPathname(state),
    isLoggedIn: isLoggedIn(state),
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    segmentTrack: (event, properties) => dispatch(segmentTrack(event, properties)),
    redirectToShowYourDoctor: () => dispatch(push(showYourDoctor.toPath())),
  };
};
export const ShowYourDoctor = connect(mapStateToProps, mapDispatchToProps)(ShowYourDoctorRenderer);
